__turbopack_context__.v({
  "className": "k2d_43d59d15-module__jbj9_q__className",
});
